const generateLocationId = (
  provinceCode: string,
  districtCode?: string,
  wardCode?: string
) => {
  if (!districtCode) {
    return `${provinceCode}0000`;
  }
  if (!wardCode) {
    return `${districtCode}00`;
  }
  return wardCode;
};

export default {
  generateLocationId,
};
